<template>
    <div>
        <selected-filters :selected="filterValues" @delete-filter="clearFilter" />
        <price-filter
            :filter-values="filterValues"
            :filters="filters"
            :label="$t('price')"
            :currency="currency"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.supplierName && filters.supplierName.length > 1 && isTO1"
            :filter-values="filterValues"
            :filters="filters"
            filter="supplierName"
            @change="change($event)"
        />
        <checkbox-filter
            v-if="filters.dates && filters.dates.length > 1"
            :filter-values="filterValues"
            :filters="filters"
            filter="dates"
            :pluralization="false"
            :date-filter="true"
            @change="change($event)"
        />
        <name-filter
            :filter-values="filterValues"
            label="activitiesDataStore name"
            :filters="filters"
            filter="name"
            @change="change($event)"
        />
        <name-filter
            :filter-values="filterValues"
            label="Activities description"
            :filters="filters"
            filter="shortDescription"
            @change="change($event)"
        />
        <filtered-mobile-button
            v-if="$breakpoint.smAndDown"
            class="sticky-button"
            :count="filteredOffersCount"
            :visible="Object.keys(filterValues).length > 0"
            @change-mode="goToOffers"
            @clear-filters="reset"
        />
    </div>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import CheckboxFilter from '~/components/search/filters/CheckboxFilter.vue'
    import FilteredMobileButton from '~/components/snippets/FilteredMobileButton.vue'
    import NameFilter from '~/components/filters/NameFilter.vue'
    import SelectedFilters from '~/components/snippets/SeletedFilters.vue'
    import PriceFilter from '~src/components/search/filters/priceFilter.src'
    import {FiltersBase} from '@/components/search/FiltersBase.vue'

    @Component({
        components: {
            PriceFilter,
            CheckboxFilter,
            FilteredMobileButton,
            NameFilter,
            SelectedFilters,
        },
    })
    export class SimpleTourFilters extends FiltersBase {}

    export default SimpleTourFilters
</script>
